// extracted by mini-css-extract-plugin
export default {"PageContainer":"_PageContainer--fjEmK","InactiveTokenWarning":"_InactiveTokenWarning--kJJRy"};